import Link from 'next/link';
import { shouldOpenInNewTab } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import type { HyperlinkType } from './master-text-block.types';
import { Icon } from '@workspace/ui/common';

export const RenderTextLink = ({ textLink }: { textLink?: HyperlinkType }) => {
  const cleanText = stripInvisibles(textLink?.text || '').trim();
  if (!cleanText) return null;
  const link = textLink?.link;
  if (!link) return null;

  const href = link.href ?? link.url ?? link.externalUrl ?? '';
  if (!href) return null;

  const openInNewTab = shouldOpenInNewTab(link);

  return (
    <Link
      href={href}
      target={openInNewTab ? '_blank' : '_self'}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      className={`group text-primary font-heading text-base transition-colors items-center inline-flex gap-1 hover:no-underline ${
        textLink.isBold ? 'font-bold' : 'font-semibold'
      }`}
    >
      {cleanText}
      <Icon
        name="arrowRightIcon"
        className="transition-transform duration-300 ease-in-out group-hover:translate-x-1 text-primary"
      />
    </Link>
  );
};
